/* RESPONSIBLE TEAM: team-self-serve */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'early_stage_graduations';
  },
});
